import { FC } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import ConversationsList from '../../../../components/messaging/conversations-list';
import { MobileMessagingRoutes, DesktopMessagingRoutes } from './Routes';

export const MessagingGlobalStyle = createGlobalStyle`
#page {
  padding-left: 0;
  height: 100vh;

  @media (max-width: 900px) { 
    height: calc(100vh - 4rem);
  }
  @media (max-width: 600px) {
  padding-right: 0;
  }
}
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 300px min-content auto;
  grid-template-rows: 100%;
  height: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: 200px min-content auto;
  }
  @media (max-width: 600px) {
    grid-template-columns: auto min-content;
  }
`;

const HorizontalBar = styled.div`
  border-left: 1px solid var(--gray-200);
  margin-right: 10px;
`;

const DesktopView = styled(Container)`
  @media (max-width: 600px) {
    display: none;
  }
`;

const MobileView = styled(Container)`
  @media (min-width: 600px) {
    display: none;
  }
`;

const MentorMessaging: FC = () => {
  return (
    <>
      <MessagingGlobalStyle />

      <DesktopView>
        <ConversationsList />
        <HorizontalBar />
        <DesktopMessagingRoutes />
      </DesktopView>

      <MobileView>
        <MobileMessagingRoutes />
      </MobileView>
    </>
  );
};

export default MentorMessaging;
